import React, { useState } from "react";
import Header from "../components/Header";
import BooksSection from "../sections/BooksSection";
import SongsSection from "../sections/SongsSection";
import { useSystemTheme } from "../utils/useSystemTheme";

const HomeUI = ({ onPlay, onBookAccessDenied, fadeOut, showAnimation, setCenterText }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [activeTab, setActiveTab] = useState("Кітаптар");
    const theme = useSystemTheme();

    const gradientClass =
        theme === "dark"
            ? "bg-gradient-to-tr from-[#1f2937] via-[#111827] to-[#0f172a]"
            : "bg-gradient-to-tr from-[#FFF8F3] via-[#FFF8F3] to-[#FFF8F3]";

    const buttonBase =
        "px-4 py-2 rounded-[4vw] border-none font-semibold transition";

    const getButtonClass = (tab) => {
        const isActive = activeTab === tab;
        if (isActive) {
            return theme === "dark"
                ? `${buttonBase} bg-[var(--app-color)] text-white`
                : `${buttonBase} bg-[var(--app-color)] text-white`;
        } else {
            return theme === "dark"
                ? `${buttonBase} bg-[var(--app-color)] text-white`
                : `${buttonBase} bg-[#F2B48A] text-white`;
        }
    };

    return (
        <div
            className={`flex flex-col min-h-screen ${gradientClass}`}
            style={{ opacity: showAnimation ? (fadeOut ? 1 : 0) : 1 }}
        >
            <Header />
            <div className="flex-grow space-y-6 px-4 py-6">
                <div className="flex space-x-4 mb-4 px-4">
                    <button
                        onClick={() => {
                            setActiveTab("Кітаптар");
                            setCenterText("Кітаптар");
                        }}
                        className={getButtonClass("Кітаптар")}
                    >
                        Кітаптар
                    </button>

                    <button
                        onClick={() => {
                            setActiveTab("Күйтабақ");
                            setCenterText("Күйтабақ");
                        }}
                        className={getButtonClass("Күйтабақ")}
                    >
                        Күйтабақ
                    </button>
                </div>

                <div className="relative pb-[160px]">
                    <div className={activeTab === "Кітаптар" ? "block" : "hidden"}>
                        <BooksSection
                            selectedCategory={selectedCategory}
                            onPlay={onPlay}
                            onBookAccessDenied={onBookAccessDenied}
                        />
                    </div>
                    <div className={activeTab === "Күйтабақ" ? "block" : "hidden"}>
                        <SongsSection
                            selectedCategory={selectedCategory}
                            onPlay={onPlay}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeUI;